export const triangleStyle: React.CSSProperties = {
  width: 0,
  height: 0,
  borderStyle: "solid",
  borderWidth: "0.7rem 0.6rem 0.7rem 0",
  borderColor: "transparent #6c808b transparent transparent",
};
